<template>
  <div class="trade-offline-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="订单详情" :showBack="true"></my-header>
    <div v-if="tradeOffline.deposit" class="offline-top-bg">
      <div class="title">
        订金金额&nbsp;&nbsp;&nbsp;¥{{tradeOffline.deposit}}元
      </div>
    </div>
    <div class="info general-box-shadow">
      <div class="trade-offline-info">
        <div class="offline-info-item">
          <div class="info-field-name">订单类型:</div>
          <div>
            <span v-if="tradeOffline.type == '1'">全款订单</span>
            <span v-if="tradeOffline.type == '2'">团购订单</span>
            <span v-if="tradeOffline.type == '3'">普通订单</span>
          </div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单状态:</div><div>{{offlineStatusMap[tradeOffline.status]}}</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">订单编号:</div><div>{{tradeOffline.orderNo}}</div>
        </div>
        <div class="offline-info-item">
          <div class="info-field-name">下单时间:</div><div>{{tradeOffline.createTime | longTime}}</div>
        </div>
      </div>
      <div class="trade-offline-info">
        <div class="offline-info-item">
          <span class="info-field-name">订单备注:</span><span>{{tradeOffline.remarks?tradeOffline.remarks:'无'}}</span>
        </div>
        <div class="offline-info-item">
          <span class="info-field-name">联<span style="margin-left: 0.5em"></span>系<span style="margin-left: 0.5em"></span>人:</span><span>{{tradeOffline.name}}</span>
        </div>
        <div class="offline-info-item">
          <span class="info-field-name">联系电话:</span><span>{{tradeOffline.phone}}</span>
        </div>
      </div>
    </div>
    <div v-if="tradeOffline.status == '1' || tradeOffline.status == '2'" class="offline-btn-group">
      <div v-if = "tradeOffline.status == '2'" class="general-btn" @click = "toOfflineRefund(tradeOffline.id)">申请退订</div>
      <div v-if = "tradeOffline.status == '1'" class="general-btn" @click = "cancelOffline(tradeOffline.id)">取消订单</div>
      <div v-if = "tradeOffline.status == '1'" class="general-btn pay-btn" @click="payOffline(tradeOffline.id)">去支付</div>
      <div v-if = "tradeOffline.status == '2'" class="general-btn pay-btn" @click="uploadPayVoucher(tradeOffline.id,tradeOffline.shopName)">上传合同凭证</div>
      <div v-if = "tradeOffline.status == '2'" class="general-btn pay-btn" @click="payTailMoney(tradeOffline.id,tradeOffline.shopName)">微信支付尾款</div>
    </div>
    <div v-if="isCancelOffline" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancel()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您确定要取消订单?</div>
      <div class="agree-btn" @click="confirmCancel()">取消订单</div>
    </div>
    <div v-if="isCancelOffline" class="pay-box"></div>

    <div v-if="isPayOffline" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelPay()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您确定要支付订单?</div>
      <div class="agree-btn" @click="payTraderOffline()">去支付</div>
    </div>
    <div v-if="isPayOffline" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import payUtil from '../../utils/Pay'
  import tradeOfflineService from '../../service/trade/TradeOfflineService'

  export default {
    name: 'OfflineDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        prePayInfo:{},
        tradeOfflineId:'',
        tradeOffline:{},
        activity:{},
        offlineStatusMap:[],
        isCancelOffline:false,
        isPayOffline:false,
        operationOfflineId:'',
        isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){
      this.tradeOfflineId = this.$route.query.tradeOfflineId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getTradeOfflineDetail();
    },
    methods: {
      async getTradeOfflineDetail(){
        let {code,msg,data} = await tradeOfflineService.detail(this.tradeOfflineId);
        if(code == '0'){
          this.activity = data.activity;
          this.tradeOffline = data.offline;
          this.offlineStatusMap = data.offlineStatusMap;
        }
      },
      toOfflineRefund(tradeOfflineId){
        this.global.orderOfflineStatus = this.orderOfflineStatus;
        this.$router.push({name: 'OfflineRefund', query: {tradeOfflineId}})
      },
      //上传支付凭证
      uploadPayVoucher(tradeOfflineId,shopName){
        this.global.orderOfflineStatus = this.orderOfflineStatus;
        this.$router.push({name: 'OfflinePayVoucher', query: {tradeOfflineId,shopName}})
      },
      //支付尾款
      payTailMoney(tradeOfflineId,shopName){
        this.global.orderOfflineStatus = this.orderOfflineStatus;
        this.$router.push({name: 'OfflineTailMoney', query: {tradeOfflineId,shopName}})
      },
      cancelOffline(id){
        this.operationOfflineId = id;
        this.isCancelOffline = true;
      },
      cancel(){
        this.isCancelOffline = false;
      },
      async confirmCancel(){
        tradeOfflineService.cancelOffline(this.operationOfflineId).then(res =>{
          if(res.code == '0'){
            Toast('取消订单成功!');
            this.isCancelOffline = false;
          }else{
            Toast(res.msg);
          }
        })
      },
      payOffline(id){
        this.operationOfflineId = id;
        this.isPayOffline = true;
      },
      cancelPay(){
        this.isPayOffline = false;
      },
      async payTraderOffline(){
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          let result = await tradeOfflineService.payOffline(this.operationOfflineId,'1');
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          let result = await tradeOfflineService.payOffline(this.operationOfflineId);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.isPayOffline  = false;
                that.getTradeOfflineDetail();
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-offline-detail-page {
    height: 100vh;
    background: white;
    font-size: 0.32rem;
    .offline-top-bg{
      height: 1.06rem;
      background-image: url(../../assets/appointment/icon-top-bg.png);
      .title{
        padding-top: 0.28rem;
        padding-left: 0.3rem;
        font-size: 0.36rem;
      }
    }
    .info{
      width: 6.90rem;
      margin: 0.3rem 0.2rem 0 0.3rem;
    }
    .offline-btn-group{
      display: flex;
      justify-content: flex-end;
      margin-top: 0.42rem;
      margin-right: 0.6rem;
    }
    .general-btn{
      margin-left: 0.2rem;
    }
  }
</style>
